import { appData } from '@/mocks/comicData';

export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[720px] mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0">
            <img
              src={appData.qrCode}
              alt="扫码下载古古漫画网客户端"
              className="w-40 h-40 rounded-xl"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
              {appData.title}
            </h2>
            <p className="text-sm text-foreground-600 mb-4">{appData.subtitle}</p>
            <div className="flex flex-wrap gap-2 justify-center md:justify-start">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="px-3 py-1 text-xs rounded-full bg-accent-50 text-accent-700 border border-accent-200 whitespace-nowrap"
                >
                  {feat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}